import script from "./DataConsentContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataConsentContent.vue?vue&type=script&lang=ts&setup=true"

import "./DataConsentContent.vue?vue&type=style&index=0&id=3d9704a3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9704a3"]])

export default __exports__